<template>
	<div>

		<!-- 默认页面 -->
		<div>
			<el-row style="text-align: right;">
				<el-button
					style="background-color: #006E4B; color: #FFFFFF; border: 1px #006E4B solid; font-size: 17px; padding: 10px 20px;"
					@click="setDepartment(null)">
					调整部门</el-button>
			</el-row>

			<!-- 默认 -->
			<el-row style="margin-top: 10px;">
				<el-table :header-cell-style="{background:'#F0F0F0',color:'#000000'}"
					:row-class-name="tableRowClassName" ref="multipleTable" :data="tableData" tooltip-effect="dark"
					style="width: 100%;" height="520" @selection-change="handleSelectionChange">
					<el-table-column type="selection" width="55">
					</el-table-column>
					<el-table-column align="center" label="序号" width="100">
						<template slot-scope="scope_1">{{scope_1.$index + 1}}</template>
					</el-table-column>
					<el-table-column prop="staff_name" align="center" label="姓名" width="150"></el-table-column>
					<el-table-column prop="organize_name" align="center" label="组织架构"></el-table-column>
					<el-table-column prop="post_name" align="center" label="职位" width="150"></el-table-column>
					<el-table-column prop="staff_telephone" align="center" label="手机号" width="150"></el-table-column>
					<el-table-column align="center" label="操作" width="150">
						<template slot-scope="scope">
							<img src="../../../assets/调整部门.png" @click="setDepartment(scope.row.id)" />
						</template>
					</el-table-column>
				</el-table>

				<!-- 分页 -->
				<el-row style="margin-top: 10px; text-align: center;">
					<el-pagination background @current-change="handleCurrentChange" :page-size="page_size"
						layout=" prev, pager, next, jumper" :total="total">
					</el-pagination>
				</el-row>
			</el-row>
		</div>

		<!-- 调薪部门弹出层 -->
		<el-dialog center :visible.sync="setDepartmentVisible" width="30%" :close-on-click-modal="false">
			<template slot="title"><span style="font-weight: bold;">调整部门</span></template>
			<el-form :model="form" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
				<el-form-item label="调整部门" prop="project_id" style="margin-top: 20px;">
					<el-cascader v-model="form.project_id" style="width: 100%;" :props="props">
					</el-cascader>
				</el-form-item>
				<el-form-item label-width="0" style="text-align: center;">
					<el-button type="primary"
						style="background-color: #006E4B; border: 1px #006E4B solid; width: 100px;" @click="Save">保存
					</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			var organizeFind = async (e, spare8) => {
				var organizeList = await this.$globals.AxiosPost("organize/findHierarchy", {
					identification: "1",
					organize_id: e,
					spare8: spare8,
				});
				return organizeList.data;
			};
			return {
				//列表相关
				page_num: 1,
				page_size: 10,
				total: 0,
				tableData: [],

				//页面相关
				setDepartmentVisible: false,

				//条件
				condition: {
					//部门id
					project_id: "",
					//标识
					flag: ""
				},

				//表单数据
				form: {
					//多条修改数组
					ids: [],

					//调整部门id
					project_id: [],
				},

				//表单验证
				rules: {
					project_id: [{
						required: true,
						message: '请选择部门！',
						trigger: 'blur'
					}],
				},

				//级联下拉配置
				props: {
					lazy: true,
					async lazyLoad(node, resolve) {
						if (node.level === 0) {
							return resolve(await organizeFind('', 'group'));
						} else {
							resolve(await organizeFind(node.data.id, ''));
						}
					},
					value: "id",
					label: "organize_name",
					children: "organizeList",
					checkStrictly: true,
				},
			}
		},
		methods: {
			//查询
			async Find() {
				var url = "staff/selectWhole",
					record = {
						page_num: this.page_num,
						page_size: this.page_size,
						organize_id: this.condition.project_id,
					};

				var data = await this.$globals.AxiosPost(url, record);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.tableData = data.list;
						this.total = data.total;
					} else {
						this.$message.warning('请求失败！请稍后重试');
					}
				}
			},
			//分页
			handleCurrentChange(val) {
				this.page_num = val;
				this.Find();
			},
			//列表复选框选择
			handleSelectionChange(val) {
				this.form.ids = [];
				val.forEach(item => {
					this.form.ids.push(item.id);
				})
			},
			//设置上级部门页面
			setDepartment(e) {
				var ids = [];
				if (e == null && this.form.ids.length <= 0) {
					this.$message.warning('请先选择操作数据');
					return false;
				} else if (e == null && this.form.ids.length > 0) {
					ids = this.form.ids
				} else {
					ids = [e]
				}
				this.form.ids = ids;
				this.setDepartmentVisible = true;
			},
			//保存
			Save() {
				this.$refs["ruleForm"].validate(async (valid) => {
					if (valid) {
						var organize_ids = "";
						this.form.project_id.forEach(item => {
							organize_ids += item + ",";
						})
						organize_ids = organize_ids.substring(0, organize_ids.length - 1);
						var url = "staff/adjustment",
							record = {
								ids: this.form.ids,
								organize_ids: organize_ids,
								project_id: this.form.project_id[this.form.project_id.length - 1]
							};
						var data = await this.$globals.AxiosPost(url, record);
						if (data === '-2000') {
							this.$message.error('服务器未响应！请稍后重试');
						} else {
							var code = data.code;
							var data = data.data;
							if (code === '200') {
								this.$message.success(data);
								this.setDepartmentVisible = false;
								this.Find();
								//刷新结构页面
								this.$emit("structureFind");
							} else {
								this.$message.warning(data);
							}
						}
					} else {
						console.log('error submit!!');
						return false;
					}
				})
			}
		}
	}
</script>

<style scoped="scoped">
</style>



// WEBPACK FOOTER //
// Jtzzjggl_staff.vue?d2db070e